import { Actions } from '../../components/product-table/columns/actions-column';
import { ExtendedCost } from '../../components/product-table/columns/extended-cost-column';
import { ItemCode } from '../../components/product-table/columns/item-code-column';
import { ProductNameWithLabels } from '../../components/product-table/columns/product-name-with-labels-column';
import { QOH } from '../../components/product-table/columns/qoh-column';
import { Reorder } from '../../components/product-table/columns/reorder-column';
import { getUnitsSoldColumn } from '../../components/product-table/columns/sales-columns';
import { Type } from '../../components/product-table/columns/simple-columns';
import { Size } from '../../components/product-table/columns/size-column';
import { VendorName } from '../../components/product-table/columns/vendor-name-column';
import { FiltersPopover } from '../../components/product-table/filters/filters-popover';
import { HideDisabledFilter } from '../../components/product-table/filters/hide-disabled-filter';
import { NotSoldInFilter } from '../../components/product-table/filters/not-sold-in-filter';
import { SoldInFilter } from '../../components/product-table/filters/sold-in-filter';
import { TotalValue } from '../../components/product-table/filters/total-value-filter';
import { ProductReport } from '../../components/product-table/product-report';
import type { StrictColumnDef } from '../../components/tanstack-table/column';
import type { Product, SaleStatDays } from '../../data/product';
import type { Filters } from '../../hooks/products';
import { productReportsLayout } from '../../router';

const defaultFilters: Filters = {
  soldIn: 365,
  notSoldIn: 180,
  minimumInventory: 1,
};

const soldInDays: SaleStatDays[] = [90, 180, 365];
const notSoldInDays: SaleStatDays[] = [30, 60, 90, 180];

const columnsFor = (filters: Filters): StrictColumnDef<Product>[] => [
  VendorName,
  ItemCode,
  ProductNameWithLabels,
  Type,
  Size,
  getUnitsSoldColumn(filters.soldIn || 365),
  getUnitsSoldColumn(filters.notSoldIn || 180),
  QOH,
  Reorder,
  ExtendedCost,
  Actions,
];

export function UnderperformingInventoryReport() {
  const products = productReportsLayout.useLoaderData();

  return (
    <ProductReport
      products={products}
      title="Underperforming Inventory"
      defaultFilters={defaultFilters}
      columns={columnsFor}
      toolbarLeft={
        <FiltersPopover defaultFilters={defaultFilters}>
          <HideDisabledFilter />
          <SoldInFilter overrideSoldInDays={soldInDays} />
          <NotSoldInFilter overrideSoldInDays={notSoldInDays} />
        </FiltersPopover>
      }
      toolbarRight={<TotalValue />}
    />
  );
}
